<template>
  <v-card elevation="4" class="rounded-sm">
    <v-card-title>
      <div class="text-subtitle-1 font-weight-bold">Estímulos</div>
      <v-spacer></v-spacer>
      <v-btn
        fab
        color="secondary"
        icon
        v-if="!readonly"
        @click="
          estimulos.push({
            estimulo: '',
            fecha: null,
            motivo: '',
            descripcion: '',
            estatus: true,
          })
        "
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" v-for="(estimulo, index) in estimulos" :key="index">
            <v-card color="primary" class="ui-module-card ui-module-fade-in-up">
              <v-card-title>
                <v-text-field
                  label="Estímulo"
                  v-model="estimulos[index].estimulo"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  hide-details
                  :readonly="readonly"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn color="error" icon v-if="!readonly" @click="estimulos.splice(index, 1)">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  label="Motivo"
                  v-model="estimulos[index].motivo"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  :readonly="readonly"
                ></v-text-field>
                <v-menu
                  v-model="menuFechaEstimulo[index]"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="estimulo.fecha"
                      label="Fecha"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      rounded
                      filled
                      dense
                      color="secondary"
                      background-color="primary"
                      :rules="required"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="estimulo.fecha"
                    @input="menuFechaEstimulo[index] = false"
                    :readonly="readonly"
                  ></v-date-picker>
                </v-menu>
                <v-text-field
                  label="Descripción"
                  v-model="estimulos[index].descripcion"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  :readonly="readonly"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    estimulos: {
      type: Array,
      required: true,
    },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      required: [(v) => !!v || 'Este campo es requerido'],
      menuFechaEstimulo: [],
    }
  },
}
</script>
